import axios from 'axios';
import store from '../store/store'
import {v4 as uuidv4} from 'uuid';

const url = '/api/v1/external/contexts';

  

class ContextService {
    
    static addContexts(contexts, token) {
        
        ////console.log('ContextService.addContexts has: ' + JSON.stringify(contexts))
        
        return axios.post(url, {
            data: contexts
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })


    }

    static deleteContextsByOwner(ownerId, token) {
        
        return axios.delete(url + '/byOwner/' + ownerId, {
            headers: {Authorization: `Bearer ${token}`}
        })
        
    }
    
    static getContexts(ownerId, activeOnly, token) {
        
        let localUrl = url + "/" + ownerId

        if(!activeOnly) {
            localUrl += "/all"
        }
        
        return axios.get(localUrl, {
            headers: {Authorization: `Bearer ${token}`}
        })

        

    }

    static updateContexts(contexts, token) {
        
        return axios.put(url, {
            data: contexts
        }, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }



}

export default ContextService; 